// @flow

import React from "react";
import { localize } from "redux-i18n";
import type { FormProps } from "redux-form";

import { View, Button, SchemaTable } from "@components";
import type { RtwFormQuestion } from "@modules/service/reducer/rtw/types";

type OwnProps = $Exact<{
  data: ?Array<RtwFormQuestion>,
  schema: Object,
  disabled?: boolean,
  onChange: (data: Array<RtwFormQuestion>) => void,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
  ...$Exact<FormProps>, // https://stackoverflow.com/a/44771268/220839
}>;

export class RtwFormForm extends React.Component<Props> {
  static defaultProps = {
    onChange: () => {},
  };

  get defaultQuestion() {
    return [
      {
        id: null,
        questionType: null,
        isMandatory: false,
        questionText: null,
        selectableValues: [],
        isActive: true,
        type: "QUESTION",
      },
    ];
  }

  get data() {
    return this.props.data || this.defaultQuestion;
  }

  get schema() {
    return this.props.schema;
  }

  get uiSchema() {
    return {
      "ui:order": [
        "id",
        "questionType",
        "isMandatory",
        "questionText",
        "selectableValues",
        "isActive",
      ],
      id: {
        "ui:widget": "text",
        "ui:title": "ID",
        "ui:options": {
          editable: false,
          disabled: (item: Object) => !item.isActive,
        },
      },
      questionType: {
        "ui:widget": "select",
        "ui:options": {
          minWidth: "150px",
          required: true,
          disabled: (item: Object) => !item.isActive,
        },
      },
      isMandatory: {
        "ui:widget": "checkbox",
        "ui:title": " ",
        "ui:options": {
          minWidth: "20px",
          disabled: (item: Object) => item.questionType === "CONFIRMATION",
        },
      },
      questionText: {
        "ui:widget": "textarea",
        "ui:options": {
          minWidth: "250px",
          required: true,
          disabled: (item: Object) => !item.isActive,
        },
      },
      selectableValues: {
        "ui:widget": "custom-answer-type-switch",
        "ui:title": "Answers",
        "ui:options": {
          minWidth: "250px",
          disabled: (item: Object) => !item.isActive,
        },
      },
      isActive: {
        "ui:widget": "switch",
        "ui:title": "Active",
        "ui:options": {
          minWidth: "100px",
        },
      },
    };
  }

  handleAdd = () => {
    this.props.onChange([...this.data, ...this.defaultQuestion]);
  };

  handleChange = (data: Array<RtwFormQuestion>) => {
    const managedData = data.map(d => ({
      ...d,
      type:
        ["MULTI_SELECT", "SINGLE_SELECT"].indexOf(d.questionType) !== -1 ? "QUESTION" : "STATEMENT",
      isMandatory: d.questionType === "CONFIRMATION" ? false : d.isMandatory,
    }));

    this.props.onChange(managedData);
  };

  render() {
    return (
      <View>
        {this.props.disabled ? null : (
          <View alignSelf="end">
            <Button
              className="link alert-sgs__add-button"
              materialIcon="add"
              onClick={this.handleAdd}
              label={this.props.t("RETURN_TO_WORK_DETAILS_ADD_QUESTION")}
            />
          </View>
        )}
        <SchemaTable
          tableData={this.data}
          schema={this.schema}
          uiSchema={this.uiSchema}
          onChange={this.handleChange}
          disabled={!!this.props.disabled}
          allowReordering
          allowDeletes
        />
      </View>
    );
  }
}

export default localize()(RtwFormForm);
